import { render } from "./SubParagraph1.vue?vue&type=template&id=9313a6fe&scoped=true"
import script from "./SubParagraph1.vue?vue&type=script&lang=js"
export * from "./SubParagraph1.vue?vue&type=script&lang=js"

import "./SubParagraph1.vue?vue&type=style&index=0&id=9313a6fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9313a6fe"]])

export default __exports__